import {Skeleton} from '~/shared/components/Loaders';
import {getLocalizationService} from '~/shared/services/localisationService';
import {Title} from '~/shared/components/UserTransactions/shared';
import {Root} from '~/shared/components/UserTransactions/components/styled';
import CustomTable from '~/shared/components/UserTransactions/components/CustomTable/CustomTable';

import CompanyAnnouncement from './CompanyAnnouncement';

type DesktopTotalsTable = {
  companyAnnouncement: string;
  columns: Column[];
  paymentsWithSummaryRow: any[];
  className?: string;
  boldAllPrices: boolean;
  tableHeaderCustomColor?: string;
  customTableFooterColor?: string;
};

type Column = {
  name: string;
  label: string;
  hideLabel?: boolean;
  grow?: boolean;
  width?: number;
};

const DesktopTotalsTable = ({companyAnnouncement, columns, paymentsWithSummaryRow, className, tableHeaderCustomColor, customTableFooterColor, boldAllPrices}: DesktopTotalsTable) => {
  const {t} = getLocalizationService();
  return (
    <Root className={className}>
      <Title as="h3">{t('total_payments_by_payment_type')}</Title>
      {companyAnnouncement && <CompanyAnnouncement companyAnnouncement={companyAnnouncement} />}
      {/* @ts-expect-error CustomTable needs to be rewritten as ts */}
      <CustomTable
        columns={columns as Column[]}
        rows={paymentsWithSummaryRow}
        skeletonComponent={<Skeleton width={88} height={16} />}
        useTranslate
        summary={t('totals_table_summary')}
        boldAllPrices={boldAllPrices}
        withRoundedCorners
        tableHeaderCustomColor={tableHeaderCustomColor}
        customTableFooterColor={customTableFooterColor}
      />
    </Root>
  );
};

export default DesktopTotalsTable;
